import { applyMiddleware, createStore as originalCreateStore, Middleware, Store, Action } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { rootReducer, ResultsState } from './reducers';
import memes from '../../memes';
import { SearchResultsQuery } from '@websky/graphql';
import rootSaga from './sagas';

export const createStore = memes(
	(searchResults?: SearchResultsQuery['SearchResult']): Store<ResultsState> => {
		const saga = createSagaMiddleware();
		const middleware: Middleware[] = [saga];

		const baseInitialState = rootReducer(undefined, { type: '@@INIT' });
		const newInitialState: ResultsState = searchResults ? { ...baseInitialState, searchResults } : baseInitialState;

		if (process.env.NODE_ENV === 'development') {
			middleware.push(require('redux-logger').default);
		}

		const store = originalCreateStore<ResultsState, Action, {}, {}>(
			rootReducer,
			newInitialState,
			applyMiddleware(...middleware)
		);

		saga.run(rootSaga);

		return store;
	}
);
